/**
 * Created by Admin on 15.02.2018.
 */
import React from 'react'
import MessageQuickReplies from './MessageQuickReplies'
import FileDropzone from '../../../../uiKit/inputs/FileDropzone'
import ReactionBar from '../../../../uiKit/ReactionBar/ReactionBar'
import ItemChipHelper from '../ItemChipHelper/ItemChipHelper'

export default class Attachment extends React.Component {
  state = {}

  handleChange(fileUrl) {
    const newMessage = JSON.parse(JSON.stringify(this.props.message))
    newMessage.attachment.payload.url = fileUrl
    this.props.updateMessage(newMessage)
  }

  addReaction() {
    const newMessage = JSON.parse(JSON.stringify(this.props.message))
    newMessage.enableReaction = true
    this.props.updateMessage(newMessage)
  }

  deleteReaction() {
    const newMessage = JSON.parse(JSON.stringify(this.props.message))
    newMessage.enableReaction = false
    this.props.updateMessage(newMessage)
  }

  render() {
    const { rtl } = this.props
    const showReactionBar = this.props.message.enableReaction

    return (
      <div style={{ width: '100%' }}>
        <div className="message">
          <FileDropzone
            value={this.props.message.attachment.payload.url}
            onChange={fileUrl => this.handleChange(fileUrl)}
            title="Replace image"
          />
          <ItemChipHelper
            enableReaction={showReactionBar}
            addReaction={() => this.addReaction()}
            onDelete={() => this.props.onDelete()}
          />
        </div>
        {showReactionBar && <ReactionBar onDelete={() => this.deleteReaction()} />}
        <MessageQuickReplies
          message={this.props.message}
          rtl={rtl}
          updateMessage={message => this.props.updateMessage(message)}
        />
      </div>
    )
  }
}
